import {
    IonGrid, IonRow, IonCol, IonList, IonRadioGroup, IonItem, IonLabel, IonRadio, IonIcon, IonButton
  } from "@ionic/react";
  import { refreshCircleOutline } from "ionicons/icons"

import { useState, useEffect } from "react";
import { getUserPaymentMethods } from "../services/apiService"
import { GlobalStore } from "../../../store/GlobalStore"
import {setCookie } from "../../../utils/cookie"
function PaymentMethods(props) {

    const [selected, setSelected] = useState("")
    const [listPaymentMethods, setListPaymentMethods] = useState([])
    const [paymentMethodValidation, setPaymentMethodValidation] = useState({
      errorMessage: "" ,
      validationPassed: true
    })

    const {
      getDeliveryDetails , setDeliveryDetails
    } = GlobalStore()
    

    

    useEffect(()=>{
      setListOfPaymentMethods()
    },[])

    const setListOfPaymentMethods = async () => {
      let listPaymentMethods = await getUserPaymentMethods() 
      setListPaymentMethods(listPaymentMethods)
    }



    const handleCardSelect = (source) => {
      let selectedCard;
      for (let i = 0 ; i < listPaymentMethods.length  ; i ++) { 
        if (listPaymentMethods[i].source === source) { 
          selectedCard = listPaymentMethods[i]
          break
        }
      }
      setSelected(source)
      const deliveryDetails = JSON.parse(sessionStorage.getItem("deliveryAddresses"))
      let addingPaymentMethod = {...deliveryDetails,   paymentMethod: selectedCard, source}
      validateSelectedCard(deliveryDetails, selectedCard, source)
      sessionStorage.setItem("deliveryAddresses", JSON.stringify(addingPaymentMethod));
      setDeliveryDetails(addingPaymentMethod)
      // setCookie("DeliveryDetails", JSON.stringify(addingPaymentMethod))
    }

    const validateSelectedCard = (deliveryDetails, selectedCard, source) => {
      let tripFare = Number(deliveryDetails.tripFare)
      if(source.includes('ryde_') ) {
        if(selectedCard.balance > tripFare) {    
          setPaymentMethodValidation({
            errorMessage: "" ,
            validationPassed: true
          })
          props.setValidPaymentMethodSelected(false)
        } else {
          
          setPaymentMethodValidation(() => {return {
            errorMessage: "Insufficient RydeCoins to proceed with booking." ,
            validationPassed: false
          }})
          props.setValidPaymentMethodSelected(true)
        }
      } else {
        props.setValidPaymentMethodSelected(false)
        setPaymentMethodValidation({
          errorMessage: "" ,
          validationPassed: true
        })
      }
    }

    return (
        <>
            <div className="card-select">
              { !paymentMethodValidation.validationPassed &&
            <div className="warning-msg" >
              <span > <img src="../img/error.svg" />  {paymentMethodValidation.errorMessage} </span>
            </div>
              }
                <IonGrid>
                  <IonRow>
                    <IonCol>
                      <IonList>
                        <h5>Select Payment Method</h5>
                        <IonRadioGroup
                          value={selected}
                          onIonChange={(e) => handleCardSelect(e.detail.value)}
                        > 
                          {
                              listPaymentMethods.map((paymentMethod)=>{
                                return (
                                  <IonItem lines="none">
                                     <IonLabel>{paymentMethod.brand === "RYDE" ? `RydeCoins ($${paymentMethod.balance})` : `${paymentMethod.brand} *** ${paymentMethod.last4}`}</IonLabel>
                                     <IonRadio
                                        slot="start"
                                        color="danger"
                                        value={paymentMethod.source}
                                      />
                                 </IonItem>
                                )
                              })

                          }
                          
                        </IonRadioGroup>
                      </IonList>
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </div>
        </>
    )
}

export default PaymentMethods;